export const getIconButtonOverrides = theme => {
  return {
    MuiIconButton: {
      styleOverrides: {
        root: {
          color: theme.palette.primary.main,
          "&:hover": {
            color: `${theme.palette.primary.main}70`,
            background: "none"
          },
          padding: 0
        }
      }
    },
    MuiTooltip: {
      styleOverrides: {
        tooltip: {
          backgroundColor: theme.palette.grey[4],
          color: theme.palette.primary.contrastText,
          padding: `${theme.spacing(1)} ${theme.spacing(1.5)}`,
          font: theme.typography.caption,
          fontSize: "12px !important",
          fontWeight: "400 !important",
          borderRadius: 8
        },
        arrow: {
          color: theme.palette.grey[4]
        },
        popper: {
          "&[data-popper-placement*='right']": {
            marginLeft: "-14px !important"
          }
        }
      }
    }
  };
};